<template>
  <div>
    <!-- ページヘッダー -->
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <h3 class="h4 text-center">
          <router-link :to="{ name: 'mypage::event::order_confirm', params: {} }">
            <i class="fa fa-chevron-left back-icon" aria-hidden="true"></i>
          </router-link>
          <b><trans-text i18nKey="ui[10][1]"/></b>
        </h3>
      </div>
    </div>
    <div class="container-fluid page-head-wrap">
      <div class="container page-head">
        <p class=" questionnaire-subhead mb-0 text-center"><trans-text i18nKey="ui[10][5]"/></p>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 offset-lg-2 col-lg-8">

          <div class="alert alert-danger mt-3" role="alert" v-if="apiErrorI18nKey">
            <b><trans-text :i18nKey="apiErrorI18nKey"/></b>
          </div>
          <!-- 入力フォーム -->
          <page-form @tryForm="tryForm"></page-form>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageForm from "page/partials/Payment/Form/PageForm.vue"

  export default {
    name:"",
    components: {
      PageForm,
    },
    data () {
      return {
        apiErrorI18nKey:"",
      }
    },
    created(){
    },
    methods:{
      tryForm(input){
        app.make("axios").post(`v1/payment`,input)
          .then(({data}) =>{
            //dd("12345",data)
            this.$router.push({ name: 'payment::complete', params: {} })
          })
          .catch(error => {
          })



      }
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Form.vue?877998a0